// Single source of truth for Job work categories (used across the app).
// App UI is English. These are the canonical selectable job categories and
// must match everywhere: Convert-to-Job dropdown, Jobs list/sidebar filters,
// Job Templates category, and the job `type` field stored in the backend.
// NOTE: "abandonment" was removed from the selectable list per user request,
// but its label is kept in LEGACY_JOB_CATEGORY_LABELS so old jobs created
// before the change still render correctly in All Jobs and other listings.

export const JOB_CATEGORIES = [
  { value: 'well_construction', label: 'Well Construction' },
  { value: 'pump_installer', label: 'Pump Installer' },
  { value: 'filters_service', label: 'Filters & Service' },
  { value: 'permits', label: 'Work Office' },
  // TEMA A (Site Inspection): categoria generica para cualquier inspeccion
  // (pozo, filtro, etc — no solo well) pedida por Alian para cotizar
  // inspecciones de Rebuild Florida sin exigir datos tecnicos del pozo.
  { value: 'site_inspection', label: 'Site Inspection' },
];

export const JOB_CATEGORY_VALUES = JOB_CATEGORIES.map((c) => c.value);

// Labels include legacy values that are no longer selectable but may still
// exist on existing job documents. "office_work" and "office_work" were
// removed from the selectable list (they duplicated "Permits" in the UI) but
// old jobs still render — mapped via LEGACY_JOB_CATEGORY_MAP below so the
// system always shows the ONE canonical name "Permits" (Alian's video:
// "no tienes un idioma claro... si es Office Work o es Permit").
const LEGACY_JOB_CATEGORY_LABELS = {
  abandonment: 'Abandonment',
};

export const JOB_CATEGORY_LABELS = {
  ...LEGACY_JOB_CATEGORY_LABELS,
  ...JOB_CATEGORIES.reduce((acc, c) => {
    acc[c.value] = c.label;
    return acc;
  }, {}),
};

export const DEFAULT_JOB_CATEGORY = 'well_construction';

// Maps legacy/old category values to the canonical ones so old records keep
// filtering correctly even before the DB migration runs.
export const LEGACY_JOB_CATEGORY_MAP = {
  new_construction: 'well_construction',
  pump_install: 'pump_installer',
  pump_service: 'pump_installer',
  permit: 'permits',
  office_work: 'permits',
  repair: 'filters_service',
  modification: 'well_construction',
  new_well: 'well_construction',
};

export const normalizeJobCategory = (value) =>
  JOB_CATEGORY_LABELS[value] ? value : LEGACY_JOB_CATEGORY_MAP[value] || value;

export const jobCategoryLabel = (value) =>
  JOB_CATEGORY_LABELS[normalizeJobCategory(value)] || value;
